import router from "../../router"; 

var responseMixin = {
  methods: {
    responseToast: function (method, type, res={}, customIcon='', customAction='') {
      let toastIcon = !!customIcon ? customIcon : (method==='DELETE' ? 'fa-trash' : (method==='PUT' ? 'fa-pencil' : '')), 
          toastText = !!customAction ? customAction : (method==='DELETE' ? 'Silme' : (method==='PUT' ? 'Düzenleme' :'Oluşturma'));
          toastText += type==='error' ? ' işleminizde hata ile karşılaşılmıştır' : ' işleminiz başarıyla tamamlanmıştır';
      if(type==='error' && !!res.error && !!res.error.data.message) {
        toastText += ': <br/>'+ res.error.data.message;
      }
      else if(type==='error' && !!res.error){
        switch(res.error.status) {
          case 400:
            toastText += ': <br/>'+ "Gönderilen verilerde doğrulama hatası oluştu.";
            break;
          case 401:
            toastText += ': <br/>'+ "Kimlik doğrulaması yapılamadı, paneli görüntüleme yetkiniz bulunmuyor.";
            break;
          case 404:
            toastText += ': <br/>'+ "Sayfa içeriği bulunamadı.";
            break;
          case 404:
            toastText += ': <br/>'+ "İşlem zaman aşımına uğradı.";
            break;
          case 413:
            toastText += ': <br/>'+ "Gönderilen dosya boyutu çok büyük  olduğu için işlem tamamlanamadı.";
            break;
          case 422:
            toastText += ': <br/>'+ "Gönderilen verilerde doğrulama hatası oluştu.";
            break;
          case 500:
            toastText += ': <br/>'+ "Sunucuda bir hata oluştu.";
            break;
          case 503:
            toastText += ': <br/>'+ "Sunucu şu anda hizmet vermiyor.";
            break;
        }
      }
      this.showToast(
        toastText,
        {
          icon: toastIcon,
          position: 'bottom-right',
          duration: 2500,
          fullWidth: false,
        },
      )
    },
    redirectTo: function (to, timeout=5) {
      setTimeout( function () {
        router.push(to);
      }, timeout);
    }
  }
}

export default {
  mixins: [responseMixin]
}